var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30396 0C5.23163 1.33807e-05 5.16228 0.0287526 5.11114 0.0798922C5.06 0.131032 5.03126 0.200388 5.03125 0.27271V5.03125H0.272705C0.200383 5.03126 0.131027 5.06 0.0798879 5.11114C0.0287486 5.16228 1.30191e-05 5.23163 0 5.30395V6.69467C1.08499e-05 6.767 0.0287455 6.83635 0.079885 6.88749C0.131025 6.93863 0.200382 6.96737 0.272705 6.96738H5.03125V11.7273C5.03126 11.7996 5.06 11.869 5.11114 11.9201C5.16227 11.9713 5.23163 12 5.30396 12H6.69468C6.767 12 6.83636 11.9713 6.88749 11.9201C6.93863 11.869 6.96737 11.7996 6.96738 11.7273V6.96738H11.7273C11.7996 6.96737 11.869 6.93863 11.9201 6.88749C11.9713 6.83635 12 6.76699 12 6.69467V5.30395C12 5.23163 11.9713 5.16228 11.9201 5.11114C11.869 5.06 11.7996 5.03127 11.7273 5.03125H6.96738V0.27271C6.96737 0.200388 6.93863 0.131032 6.88749 0.0798922C6.83635 0.0287526 6.767 1.33807e-05 6.69468 0H5.30396Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusButtonIcon);
export default __webpack_public_path__ + "static/media/plusButtonIcon.e33ba5d58883382f7a27358074b04b31.svg";
export { ForwardRef as ReactComponent };